import { CompanyTagType } from '@api';
import { Modal } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AddCompanyFormFields } from './components';
import { AddCompanyFormSchemaType, useAddCompanyForm } from './hooks';

export type AddCompanyModalPropsType = {
  companyTags: CompanyTagType[];
  opened: boolean;
  onClose: () => void;
  onSubmit: (data: AddCompanyFormSchemaType) => Promise<void>;
};

export const AddCompanyModal: React.FC<AddCompanyModalPropsType> = ({
  companyTags,
  opened,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation('companies');
  const form = useAddCompanyForm();

  const handleClose = (): void => {
    form.reset();
    onClose();
  };

  const handleSubmit = async (
    data: AddCompanyFormSchemaType
  ): Promise<void> => {
    await onSubmit(data);
    handleClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={t('ADD_COMPANY.MODAL_TITLE')}
      size="lg"
      closeOnClickOutside={false}
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <AddCompanyFormFields
            onClose={handleClose}
            companyTags={companyTags}
          />
        </form>
      </FormProvider>
    </Modal>
  );
};
